import { render, staticRenderFns } from "./PersonasTabVacaciones.vue?vue&type=template&id=a18c684a&"
import script from "./PersonasTabVacaciones.vue?vue&type=script&lang=js&"
export * from "./PersonasTabVacaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports